import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { g as getStarSVG } from './getStarSVG-C-2cPF8t.js';
import { C as ClassNamePassthrough } from '../LocalModules/storm-ui-utils/dist/esm/ClassNamePassthrough-BOut0eKj-BOut0eKj.js';

const StarRatingContainer = /*#__PURE__*/styled(ClassNamePassthrough).withConfig({
  componentId: "sc-storm-ui-30061128__sc-nmdrvs-0"
})(["/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ transform:scaleX(-1);}height:1em;vertical-align:-0.125em;pointer-events:none;"]);
const StarsContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30061128__sc-nmdrvs-1"
})(["display:flex;"]);

/**
 * Builds a string of star SVGs to be inserted into the HTML
 */
const renderStars = (rating, className, starColor) => {
  const roundedRating = Math.round(rating * 2) / 2;
  let stars = '';
  for (let i = 1; i <= 5; i++) {
    if (roundedRating === 0) {
      stars += getStarSVG(false, false, className, starColor);
    } else if (i === roundedRating + 0.5) {
      stars += getStarSVG(true, false, className, starColor);
    } else if (i <= roundedRating) {
      stars += getStarSVG(true, true, className, starColor);
    } else {
      stars += getStarSVG(false, false, className, starColor);
    }
  }
  return {
    __html: stars
  };
};
const getValidRating = rating => {
  if (rating < 0) return 0;
  if (rating > 5) return 5;
  return rating;
};
class StarRating extends PureComponent {
  render() {
    const {
      rating = 0,
      ratingSuffix,
      'aria-label': ariaLabel,
      starColor = 'gold',
      ...rest
    } = this.props;
    const validRating = getValidRating(rating);
    return /*#__PURE__*/React__default.createElement(StarRatingContainer, null, className => /*#__PURE__*/React__default.createElement(StarsContainer, _extends({}, rest, {
      role: "img",
      "aria-label": ariaLabel || `${validRating} ${ratingSuffix}`
      /** Dangerously setting innerHTML was found to be up to
       * 10x more performant than rendering as React elements
       * due to the amount of SVGs required in the StarRating component. */,
      dangerouslySetInnerHTML: renderStars(validRating, className !== null && className !== void 0 ? className : '', starColor)
    })));
  }
}
_defineProperty(StarRating, "propTypes", {
  /**
   * We automatically round the number to the nearest 0.5.
   * Any number over 5 will render as 5 stars.
   */
  rating: PT.number,
  /**
   * Use this prop to add a suffix to the aria-label.
  */
  ratingSuffix: PT.string,
  /**
   * Use this prop to provide localized aria-label in internationalized UIs.
   */
  'aria-label': PT.string,
  /**
   * Sets the color of the stars to either 'gold' or 'inkwell'
   * default is 'gold'
   */
  starColor: PT.oneOf(['gold', 'inkwell'])
});
_defineProperty(StarRating, "defaultProps", {
  rating: 0,
  ratingSuffix: 'out of 5 stars',
  'aria-label': undefined,
  starColor: 'gold'
});

export { StarRating as S };
//# sourceMappingURL=StarRating-C0841dhf.js.map
